import React, { useState } from 'react'
import { Grid } from '@material-ui/core'
import { TextField, FormControl } from '@material-ui/core'
import { Modal } from '../../common/Modal'

export const EditProductModal = ({ product, setModalOpen, okMethod }) => {
    const [formState, setFormState] = useState({
        serviceAppId: product.serviceAppId,
        appId: product.appId,
        appName: product.appName,
        url: product.url,
    })

    const formStateSet = () => {
        return !Object.keys(formState).every(
            key => formState[key] !== null && formState[key] !== ''
        )
    }

    const createForm = () => {
        return (
            <Grid>
                <FormControl>
                    <TextField
                        required={true}
                        label={'App'}
                        disabled
                        value={formState.appName}
                    />
                </FormControl>

                <FormControl>
                    <TextField
                        required={true}
                        label={'Url'}
                        onChange={e => {
                            const val = e.target.value
                            setFormState({
                                ...formState,
                                url: val,
                            })
                        }}
                        value={formState.url}
                    />
                </FormControl>
            </Grid>
        )
    }

    return (
        <Modal
            data-testid='edit-product-modal'
            title='Edit Product'
            cancelText='Close'
            okText='Save'
            okMethod={() => okMethod(formState)}
            openModal={setModalOpen}
            isOkDisabled={formStateSet()}
            maxWidth='md'
            fullWidth={true}>
            {createForm()}
        </Modal>
    )
}
